<template>
    <div>
        <notification-modal :vuexStore="vuexStore" :firstAction="firstAction" :firstActionText="firstActionText" :messageTitle="messageTitle" :message="message" :notificationType="notificationType" :resetVariable="resetVariable"></notification-modal>
    </div>
</template>

<script>
export default {
    data () {
        return {
            vuexStore: 'auth',
            messageTitle: 'Session Expired',
            message: 'Your session has expired. Please log in.',
            notificationType: 'error',
            firstAction: 'logout',
            firstActionText: 'Login',
            resetVariable: 'showSessionExpired'
        }
    },
}
</script>